import { render, staticRenderFns } from "./DashboardSidebar.vue?vue&type=template&id=2c380b32&scoped=true&"
import script from "./DashboardSidebar.vue?vue&type=script&lang=js&"
export * from "./DashboardSidebar.vue?vue&type=script&lang=js&"
import style0 from "./DashboardSidebar.vue?vue&type=style&index=0&id=2c380b32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c380b32",
  null
  
)

export default component.exports